import { render, staticRenderFns } from "./InformacionValoresComponent.vue?vue&type=template&id=552138a8&"
import script from "./InformacionValoresComponent.vue?vue&type=script&lang=js&"
export * from "./InformacionValoresComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports